var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWishlistIcon = function SvgWishlistIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#wishlistIcon_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.333 26.224a.886.886 0 0 1 0 1.77l-6.666.004a.886.886 0 0 1 0-1.77l6.666-.004ZM32 11.21c0 2.78-1.229 5.186-2.9 7.169-2.663 3.16-6.456 5.231-8.02 5.99l-.054.024a2.469 2.469 0 0 1-2.105-.025v.002c-1.253-.609-3.94-2.025-6.329-4.188C10.134 17.956 8 14.949 8 11.21c0-1.962.73-3.752 1.904-5.055 1.197-1.328 2.854-2.153 4.68-2.153 1.433 0 2.752.492 3.828 1.33A6.83 6.83 0 0 1 19.934 7a6.924 6.924 0 0 1 1.521-1.653c1.088-.847 2.415-1.345 3.822-1.345 1.883 0 3.565.815 4.779 2.13C31.262 7.437 32 9.238 32 11.21Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.746 17.24c1.426-1.693 2.476-3.723 2.476-6.03 0-1.515-.559-2.888-1.47-3.877-.886-.958-2.109-1.553-3.474-1.553-1.005 0-1.953.356-2.732.963a5.269 5.269 0 0 0-1.768 2.578.887.887 0 0 1-1.695 0c-.333-1.06-.955-1.964-1.762-2.593a4.425 4.425 0 0 0-2.738-.948c-1.3 0-2.492.599-3.36 1.563-.891.988-1.445 2.358-1.445 3.867 0 3.135 1.86 5.72 4.001 7.66 2.212 2.002 4.734 3.33 5.912 3.902l-.001.002.011.005c.079.04.184.06.299.06a.724.724 0 0 0 .27-.047l.039-.02c1.46-.709 4.996-2.636 7.437-5.532Z",
    fill: "#222038"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "wishlistIcon_svg__a",
    x: 0,
    y: 0,
    width: 40,
    height: 39.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_934_11401"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_934_11401",
    result: "shape"
  })))));
};
export default SvgWishlistIcon;